module.exports = __webpack_public_path__ + "e86211d3c63180ce62330636ae45e2cc.fbx";